/* ---------------------------------------------------------------------
   SFS lead-context collector

   REPLACES the former IP-geolocation script (ipify -> ipinfo.io ->
   api.sweepersandfloorscrubbers.net). That backend was disabled, so every
   pageview made two third-party calls and discarded the result, while an
   ipinfo API token sat exposed in this public asset.

   This version is FIRST-PARTY ONLY: no external calls, no IP lookup, no
   API token. It records how a visitor found the site and what they looked
   at, in their own browser. Read by snippets/sfs-quote-form.liquid and
   attached to quote requests.

   This file keeps its old name because layout/theme.liquid already loads it
   site-wide; renaming it would mean editing the layout.
   --------------------------------------------------------------------- */
(function () {
  'use strict';

  var VKEY = 'sfs_visitor';      // persists across visits
  var SKEY = 'sfs_session';      // this browsing session only
  var SESSION_MS = 30 * 60 * 1000;

  function read(store, key) {
    try { var v = store.getItem(key); return v ? JSON.parse(v) : null; }
    catch (e) { return null; }
  }
  function write(store, key, val) {
    try { store.setItem(key, JSON.stringify(val)); } catch (e) { /* private mode */ }
  }

  // Where did they come from? Null means an internal link.
  function classify(ref) {
    if (!ref) return 'Direct / bookmark';
    var h;
    try { h = new URL(ref).hostname.replace(/^www\./, ''); }
    catch (e) { return 'Direct / bookmark'; }

    var self = location.hostname.replace(/^www\./, '');
    if (h === self) return null;

    var map = [
      [/(^|\.)google\./,            'Google'],
      [/(^|\.)bing\./,              'Bing'],
      [/(^|\.)yahoo\./,             'Yahoo'],
      [/duckduckgo\./,              'DuckDuckGo'],
      [/ecosia\./,                  'Ecosia'],
      [/chatgpt\.|openai\./,        'ChatGPT'],
      [/perplexity\./,              'Perplexity'],
      [/claude\.ai|anthropic\./,    'Claude'],
      [/gemini\.google|bard\./,     'Gemini'],
      [/copilot\.microsoft/,        'Microsoft Copilot'],
      [/facebook\.|fb\.com/,        'Facebook'],
      [/instagram\./,               'Instagram'],
      [/linkedin\.|lnkd\.in/,       'LinkedIn'],
      [/youtube\.|youtu\.be/,       'YouTube'],
      [/reddit\./,                  'Reddit'],
      [/pinterest\./,               'Pinterest'],
      [/(^|\.)x\.com|twitter\./,    'X / Twitter']
    ];
    for (var i = 0; i < map.length; i++) {
      if (map[i][0].test(h)) return map[i][1];
    }
    return 'Referral: ' + h;
  }

  var now = Date.now();

  /* ---- visitor record (first-touch attribution, never overwritten) ---- */
  var v = read(localStorage, VKEY) || { first: now, visits: 0, src: null, utm: null, land: null, last: 0 };

  if (now - (v.last || 0) > SESSION_MS) { v.visits = (v.visits || 0) + 1; }

  if (!v.src) {
    var s = classify(document.referrer);
    if (s) { v.src = s; v.land = location.pathname; }
  }

  if (!v.utm) {
    try {
      var p = new URLSearchParams(location.search);
      var parts = [p.get('utm_source'), p.get('utm_medium'), p.get('utm_campaign')].filter(Boolean);
      if (parts.length) v.utm = parts.join(' / ');
    } catch (e) {}
  }

  v.last = now;
  write(localStorage, VKEY, v);

  /* ---- session record (what they looked at this time) ---- */
  var ses = read(sessionStorage, SKEY) || { start: now, pages: 0, products: [] };
  ses.pages = (ses.pages || 0) + 1;

  if (location.pathname.indexOf('/products/') === 0) {
    try {
      var node = document.querySelector('[data-product-json]');
      if (node) {
        var title = JSON.parse(node.textContent).product.title;
        if (title && ses.products.indexOf(title) === -1 && ses.products.length < 12) {
          ses.products.push(title);
        }
      }
    } catch (e) {}
  }

  write(sessionStorage, SKEY, ses);
})();
